module.exports = __webpack_public_path__ + "img/search_table_empty.e769fc3e.png";